export interface Tag {
  id: string;
  name: string;
  slug: string;
  color: string;
  description?: string;
  usageCount: number;
  createdAt: string;
  updatedAt: string;
}

export interface TagListQuery {
  page?: number;
  pageSize?: number;
  q?: string;
  sort?: 'name' | 'usage' | 'recent';
}

export interface TagListResponse {
  items: Tag[];
  total: number;
  page: number;
  pageSize: number;
  totalPages: number;
}

export interface CreateTagInput {
  name: string;
  slug: string;
  color: string;
  description?: string;
}

export interface UpdateTagInput {
  name?: string;
  slug?: string;
  color?: string;
  description?: string;
}

export const TAG_COLOR_OPTIONS = [
  '#2563EB',
  '#059669',
  '#D97706',
  '#DC2626',
  '#7C3AED',
  '#0891B2',
  '#DB2777',
  '#475569',
] as const;
